import { InfoCircle } from "untitledui-js-base";

export const FinishedWithWarningsBanner = ({ msg }: { msg: string }) => {
  return (
    <div className="pb-6">
      <div className="py-3 px-4 bg-warning-50 h-[68px] flex w-full items-center rounded-lg border border-alpha-100">
        <div className="flex h-full justify-between items-center border-r border-alpha-80 pr-4 mr-4">
          <InfoCircle className="text-warning-700 h-6 w-6" />
        </div>
        <div className="h-full">
          <h2 className="text-warning-700 text-sm font-bold mb-1">Warning</h2>
          <p className="text-warning-700 text-sm font-medium">{msg}</p>
        </div>
      </div>
      <div className="-mx-6 mt-6 border-b border-alpha-40"></div>
    </div>
  );
};
